import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import FullWidthContainer from 'components/consumer/FullWidthContainer';
import ManualInputSlider from './components/ManualInputSlider';
import CustomerPhotosSlider from './components/CustomerPhotosSlider';
import EmblaCarousel from './components/EmblaCarousel';
const ImageSliderStandard = props => {
  const $ = _c(51);
  const {
    arrowPosition: t0,
    fullWidth,
    hideArrowsIfAllSlidesVisible: t1,
    variant
  } = props;
  const arrowPosition = t0 === undefined ? "standard" : t0;
  const hideArrowsIfAllSlidesVisible = t1 === undefined ? false : t1;
  const {
    imageArray,
    imgArray,
    variation,
    children
  } = props.config;
  const finalImageArray = imgArray || imageArray || null;
  const [currentImgSet, setImageSet] = useState(0);
  let t2;
  if ($[0] !== currentImgSet || $[1] !== finalImageArray) {
    t2 = () => {
      if (!finalImageArray) {
        return null;
      }
      if (finalImageArray.length > 50 && currentImgSet === 0) {
        return finalImageArray.slice(0, 50);
      }
      return [...finalImageArray];
    };
    $[0] = currentImgSet;
    $[1] = finalImageArray;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [finalImageDisplay, updateImageDisplay] = useState(t2);
  const [slideIndex, setSlideIndex] = useState(0);
  let visibleSlides = props.config.visibleSlides || 1;
  let navType = props.config.navType || "Button";
  let logo = props.config.logo || "";
  let title = props.config.title || "";
  let description = props.config.description || "";
  let imageWidth = 340;
  let imageHeight = 400;
  let infinite = false;
  let afterSlideFn = null;
  let t3;
  let t4;
  if ($[3] !== currentImgSet || $[4] !== finalImageArray || $[5] !== finalImageDisplay) {
    t3 = () => {
      if (!currentImgSet || finalImageDisplay.length < 50 || !finalImageArray) {
        return;
      }
      if (currentImgSet > 0 && finalImageDisplay.length >= 50 && finalImageArray && finalImageArray.length > finalImageDisplay.length * (currentImgSet + 1) && finalImageArray.length > finalImageDisplay.length) {
        const newlength = finalImageDisplay.length * (currentImgSet + 1);
        updateImageDisplay(finalImageDisplay.concat(finalImageArray.slice(finalImageDisplay.length, newlength)));
      } else {
        if (currentImgSet > 0 && finalImageDisplay.length >= 50 && finalImageArray && finalImageArray.length < finalImageDisplay.length * (currentImgSet + 1) && finalImageArray.length > finalImageDisplay.length) {
          updateImageDisplay(finalImageDisplay.concat(finalImageArray.slice(finalImageDisplay.length)));
        }
      }
    };
    t4 = [currentImgSet, finalImageArray, finalImageDisplay];
    $[3] = currentImgSet;
    $[4] = finalImageArray;
    $[5] = finalImageDisplay;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== currentImgSet) {
    t5 = updatedSlideIndex => {
      setImageSet(currentImgSet + 1);
      setSlideIndex(updatedSlideIndex);
    };
    $[8] = currentImgSet;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const updateImageArraySize = t5;
  if (props.config.sliderConfig) {
    const {
      sliderConfig
    } = props.config;
    visibleSlides = sliderConfig.visibleSlides;
    navType = sliderConfig.navType;
    logo = sliderConfig.logo;
    title = sliderConfig.title;
    description = sliderConfig.description;
    imageWidth = sliderConfig.imageWidth;
    imageHeight = sliderConfig.imageHeight;
    infinite = sliderConfig.infinite || false;
    afterSlideFn = sliderConfig.afterSlideFn;
  }
  if (!finalImageArray && !children) {
    return null;
  }
  const ImageSliderContainer = fullWidth ? FullWidthContainer : FixedWidthContainer;
  const t6 = arrowPosition === "standard";
  const t7 = arrowPosition === "inset";
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = classNames("ImageSliderStandard__container", {
      "[&_.slider-control-centerleft]:!left-[3px] [&_.slider-control-centerright]:!right-[3px]": t6,
      "[&_.slider-control-centerleft]:!left-8 [&_.slider-control-centerright]:!right-8": t7
    });
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== finalImageDisplay || $[14] !== hideArrowsIfAllSlidesVisible || $[15] !== imageHeight || $[16] !== imageWidth || $[17] !== infinite || $[18] !== navType || $[19] !== slideIndex || $[20] !== updateImageArraySize || $[21] !== variant || $[22] !== variation || $[23] !== visibleSlides) {
    t9 = !variation || variation.value === "Manual" ? <ManualInputSlider hideArrowsIfAllSlidesVisible={hideArrowsIfAllSlidesVisible} imageArray={finalImageDisplay} imageHeight={imageHeight} imageWidth={imageWidth} infinite={infinite} navType={navType} slideIndex={slideIndex} updateImageArraySize={updateImageArraySize} visibleSlides={visibleSlides} variant={variant} /> : null;
    $[13] = finalImageDisplay;
    $[14] = hideArrowsIfAllSlidesVisible;
    $[15] = imageHeight;
    $[16] = imageWidth;
    $[17] = infinite;
    $[18] = navType;
    $[19] = slideIndex;
    $[20] = updateImageArraySize;
    $[21] = variant;
    $[22] = variation;
    $[23] = visibleSlides;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== description || $[26] !== finalImageArray || $[27] !== imageHeight || $[28] !== imageWidth || $[29] !== logo || $[30] !== navType || $[31] !== slideIndex || $[32] !== title || $[33] !== updateImageArraySize || $[34] !== variant || $[35] !== variation || $[36] !== visibleSlides) {
    t10 = variation && variation.value === "Customer Photos" ? <CustomerPhotosSlider imageArray={finalImageArray} type={"" || "General"} logo={logo} description={description} title={title} visibleSlides={visibleSlides} imageWidth={imageWidth} imageHeight={imageHeight} navType={navType} updateImageArraySize={updateImageArraySize} slideIndex={slideIndex} variant={variant} /> : null;
    $[25] = description;
    $[26] = finalImageArray;
    $[27] = imageHeight;
    $[28] = imageWidth;
    $[29] = logo;
    $[30] = navType;
    $[31] = slideIndex;
    $[32] = title;
    $[33] = updateImageArraySize;
    $[34] = variant;
    $[35] = variation;
    $[36] = visibleSlides;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  let t11;
  if ($[38] !== afterSlideFn || $[39] !== children || $[40] !== variant || $[41] !== variation) {
    t11 = variation && variation.value === "Component" && children ? <EmblaCarousel carouselConfig={{
      loop: true,
      align: "center"
    }} variant={variant} slideIndexFn={afterSlideFn}>{children}</EmblaCarousel> : null;
    $[38] = afterSlideFn;
    $[39] = children;
    $[40] = variant;
    $[41] = variation;
    $[42] = t11;
  } else {
    t11 = $[42];
  }
  let t12;
  if ($[43] !== t10 || $[44] !== t11 || $[45] !== t8 || $[46] !== t9) {
    t12 = <div className={t8}>{t9}{t10}{t11}</div>;
    $[43] = t10;
    $[44] = t11;
    $[45] = t8;
    $[46] = t9;
    $[47] = t12;
  } else {
    t12 = $[47];
  }
  let t13;
  if ($[48] !== ImageSliderContainer || $[49] !== t12) {
    t13 = <ImageSliderContainer noMobilePadding={true}>{t12}</ImageSliderContainer>;
    $[48] = ImageSliderContainer;
    $[49] = t12;
    $[50] = t13;
  } else {
    t13 = $[50];
  }
  return t13;
};
ImageSliderStandard.propTypes = {
  arrowPosition: PropTypes.oneOf(['standard', 'inset']),
  config: PropTypes.shape({
    children: PropTypes.node,
    description: PropTypes.string,
    imageArray: PropTypes.any,
    imgArray: PropTypes.array,
    logo: PropTypes.string,
    navType: PropTypes.string,
    sliderConfig: PropTypes.shape({
      afterSlideFn: PropTypes.func,
      beforeSlideFn: PropTypes.func,
      description: PropTypes.string,
      deviceOverride: PropTypes.bool,
      imageHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      imageWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      infinite: PropTypes.bool,
      logo: PropTypes.string,
      navType: PropTypes.string,
      title: PropTypes.string,
      visibleSlides: PropTypes.number,
      sliderIndex: PropTypes.number,
      fullHeight: PropTypes.bool
    }),
    title: PropTypes.string,
    variation: PropTypes.shape({
      value: PropTypes.string
    }),
    visibleSlides: PropTypes.number
  }),
  fullWidth: PropTypes.bool,
  hideArrowsIfAllSlidesVisible: PropTypes.bool,
  variant: PropTypes.oneOf(['material-swatches-sidebar', 'reviews-list'])
};
const ImageSliderStandardUI = props => {
  const $ = _c(7);
  if (props?.config?.elementAttribute?.id) {
    const t0 = props?.config?.elementAttribute?.id;
    let t1;
    if ($[0] !== props) {
      t1 = <ImageSliderStandard {...props} />;
      $[0] = props;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
      t2 = <div id={t0}>{t1}</div>;
      $[2] = t0;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t0;
  if ($[5] !== props) {
    t0 = <ImageSliderStandard {...props} />;
    $[5] = props;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  return t0;
};
ImageSliderStandardUI.propTypes = {
  arrowPosition: PropTypes.oneOf(['standard', 'inset']),
  config: PropTypes.shape({
    children: PropTypes.node,
    description: PropTypes.string,
    elementAttribute: PropTypes.shape({
      id: PropTypes.number
    }),
    imageArray: PropTypes.any,
    imgArray: PropTypes.array,
    logo: PropTypes.string,
    navType: PropTypes.string,
    sliderConfig: PropTypes.shape({
      afterSlideFn: PropTypes.func,
      beforeSlideFn: PropTypes.func,
      description: PropTypes.string,
      deviceOverride: PropTypes.bool,
      imageHeight: PropTypes.number,
      imageWidth: PropTypes.number,
      infinite: PropTypes.bool,
      logo: PropTypes.string,
      navType: PropTypes.string,
      title: PropTypes.string,
      visibleSlides: PropTypes.number,
      fullHeight: PropTypes.bool
    }),
    title: PropTypes.string,
    variation: PropTypes.shape({
      value: PropTypes.string
    }),
    visibleSlides: PropTypes.number
  }),
  fabricGridControls: PropTypes.bool,
  fullWidth: PropTypes.bool,
  hideArrowsIfAllSlidesVisible: PropTypes.bool,
  isMobileMaterialSwatches: PropTypes.bool,
  disableSliding: PropTypes.bool,
  variant: PropTypes.oneOf(['material-swatches-sidebar', 'reviews-list'])
};
export default ImageSliderStandardUI;